import { render, staticRenderFns } from "./Cleansing2.vue?vue&type=template&id=f3a49fac&scoped=true&"
import script from "./Cleansing2.vue?vue&type=script&lang=ts&"
export * from "./Cleansing2.vue?vue&type=script&lang=ts&"
import style0 from "./Cleansing2.vue?vue&type=style&index=0&id=f3a49fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a49fac",
  null
  
)

export default component.exports